import React, { Component } from "react"
import { Button, Segment, Image, Header } from "semantic-ui-react"
import { translate } from "react-translate"
import "./Temoignage.css"

import OwlCarousel from "react-owl-carousel"
import "../../Public/LandingPage/landing.css"
import "../../Public/LandingPage/thirdcarousel.css"
import "../../Public/LandingPage/aviscarousel.css"

import testimonials1 from "../../../assets/testimonials/picture1.jpg"
import testimonials2 from "../../../assets/testimonials/picture2.jpg"
import testimonials3 from "../../../assets/testimonials/picture3.jpg"
import testimonials4 from "../../../assets/testimonials/picture4.jpg"
import testimonials5 from "../../../assets/testimonials/picture5.jpg"
import testimonials6 from "../../../assets/testimonials/picture6.jpg"
import star from "../../../assets/img/star.png"

class Temoignage extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const owl = {
      0: {
        items: 1,
        loop: true
      },
      500: {
        items: 3,
        loop: true
      },
      1000: {
        items: 5,
        loop: true
      }
    }

    let text = [
      '<i aria-hidden="true" class="angle left icon"></i>',
      '<i aria-hidden="true" class="angle right icon"></i>'
    ]

    const { t } = this.props

    var sectionStyle = {
      border: "none",
      backgroundColor: "white"
    }
    var img = {
      display: "block",
      width: "100%",
      height: "auto"
    }

    return (
      <Segment id="blockTemoignage">
        {" "}
        <h2 id="titleTemoignage">Temoignages</h2>
        <p id="paraTemoignage">Ce que les artisans dissent de nous !</p>
        <OwlCarousel
          className="owl-theme"
          loop
          margin={10}
          items={3}
          center={true}
          dots={false}
          //nav
          navText={text}
          autoplay
          autoplayTimeout={3000}
          autoplaySpeed={1000}
          autoplayHoverPause
        >
          <div className="item">
            <div className="single-testimonial">
              <div className="testimonials-wrapper">
                <div className="testimonials-img-avis">
                  <Image id="avisIMG" src={testimonials1} />
                </div>
                <div id="customer" className="testimonials-person-info">
                  <Header as="h3">{t("Avis1_title")}</Header>
                  <Header as="p" textAlign="center">
                    {t("Avis1_description")}
                  </Header>

                  <Image.Group>
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                  </Image.Group>
                  <Header as="a" id="testimonials-name">
                    {t("Avis1_name")}
                  </Header>
                </div>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="single-testimonial">
              <div className="testimonials-wrapper">
                <div className="testimonials-img-avis">
                  <Image id="avisIMG" src={testimonials2} />
                </div>
                <div id="customer" className="testimonials-person-info">
                  <Header as="h3">{t("Avis2_title")}</Header>

                  <Image.Group>
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                  </Image.Group>
                  <Header as="a" id="testimonials-name">
                    {t("Avis2_name")}
                  </Header>
                </div>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="single-testimonial">
              <div className="testimonials-wrapper">
                <div className="testimonials-img-avis">
                  <Image id="avisIMG" src={testimonials3} />
                </div>
                <div id="customer" className="testimonials-person-info">
                  <Header as="h3">{t("Avis3_title")}</Header>
                  <Header as="p" textAlign="center">
                    {t("Avis3_description")}
                  </Header>

                  <Image.Group>
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                  </Image.Group>
                  <Header as="a" id="testimonials-name">
                    {t("Avis3_name")}
                  </Header>
                </div>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="single-testimonial">
              <div className="testimonials-wrapper">
                <div className="testimonials-img-avis">
                  <Image id="avisIMG" src={testimonials4} />
                </div>
                <div id="customer" className="testimonials-person-info">
                  <Header as="h3">{t("Avis4_title")}</Header>
                  <Header as="p" textAlign="center">
                    {t("Avis4_description")}
                  </Header>

                  <Image.Group>
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                  </Image.Group>
                  <Header as="a" id="testimonials-name">
                    {t("Avis4_name")}
                  </Header>
                </div>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="single-testimonial">
              <div className="testimonials-wrapper">
                <div className="testimonials-img-avis">
                  <Image id="avisIMG" src={testimonials5} />
                </div>
                <div id="customer" className="testimonials-person-info">
                  <Header as="h3">{t("Avis5_title")}</Header>
                  <Header as="p" textAlign="center">
                    {t("Avis5_description")}
                  </Header>

                  <Image.Group>
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                  </Image.Group>
                  <Header as="a" id="testimonials-name">
                    {t("Avis5_name")}
                  </Header>
                </div>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="single-testimonial">
              <div className="">
                <div className="testimonials-img-avis">
                  <Image id="avisIMG" src={testimonials6} />
                </div>
                <div id="customer">
                  <Header as="h3">{t("Avis6_title")}</Header>
                  <Header as="p" textAlign="center">
                    {t("Avis6_description")}
                  </Header>

                  <Image.Group>
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                    <Image src={star} id="star" />
                  </Image.Group>
                  <Header as="a" id="testimonials-name">
                    {t("Avis6_name")}
                  </Header>
                </div>
              </div>
            </div>
          </div>
        </OwlCarousel>
      </Segment>
    )
  }
}

export default translate("LandingComponent")(Temoignage)



// WEBPACK FOOTER //
// ./src/components/Pro/AcceuilLandingPage/Temoignage.js